import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// ✅ Always use local worker from public folder (no CDN, no module import issues)
pdfjs.GlobalWorkerOptions.workerSrc = "/pdfjs/pdf.worker.min.js";

const cx = (...xs) => xs.filter(Boolean).join(" ");

export default function PdfViewer({ url, initialPage = 1, onPageCount }) {
  const [numPages, setNumPages] = useState(null);
  const [page, setPage] = useState(initialPage);
  const [scale, setScale] = useState(1.15);

  useEffect(() => setPage(initialPage), [initialPage]);

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <button
            className="px-3 py-1.5 rounded-lg border bg-white hover:bg-slate-50 text-sm"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            ◀ Prev
          </button>

          <button
            className="px-3 py-1.5 rounded-lg border bg-white hover:bg-slate-50 text-sm"
            onClick={() => setPage((p) => Math.min(numPages || p + 1, p + 1))}
          >
            Next ▶
          </button>

          <div className="text-sm text-slate-600">
            Page <b>{page}</b> / {numPages || "—"}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            className="px-3 py-1.5 rounded-lg border bg-white hover:bg-slate-50 text-sm"
            onClick={() => setScale((s) => Math.max(0.75, s - 0.1))}
          >
            −
          </button>

          <div className="text-sm text-slate-700 w-14 text-center">
            {Math.round(scale * 100)}%
          </div>

          <button
            className="px-3 py-1.5 rounded-lg border bg-white hover:bg-slate-50 text-sm"
            onClick={() => setScale((s) => Math.min(2.0, s + 0.1))}
          >
            +
          </button>

          <input
            className="w-24 px-2 py-1.5 rounded-lg border text-sm"
            type="number"
            min={1}
            max={numPages || 9999}
            value={page}
            onChange={(e) => setPage(Math.max(1, Number(e.target.value || 1)))}
            placeholder="Go to"
          />
        </div>
      </div>

      <div className={cx("bg-white rounded-2xl border shadow-sm overflow-auto", "p-3")}>
        <Document
          file={url}
          onLoadSuccess={({ numPages }) => {
            setNumPages(numPages);
            onPageCount?.(numPages);
          }}
          loading={<div className="p-4 text-sm text-slate-600">Loading PDF…</div>}
          error={<div className="p-4 text-sm text-red-600">Failed to load PDF file.</div>}
        >
          <Page
            pageNumber={page}
            scale={scale}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>
    </div>
  );
}
